import qs from 'qs'
import axios from '@/api/apiClient'
import { richTextToBack, richTextTofront, isExStatus, addExhibitionStatus } from '@/utils/data'
import { deepClone } from '@/utils/util'
import { getServerTime } from '@/api/base'
/**
 * 会员后台-展览api
 */
const api = {
  /**
   * 展览管理
   */
  // 我发布的展览(审核通过,线上展览)
  releaseList: '/api/exhibition/myinfo/myrelease',
  // post新增展览---立即发布 put修改展览---立即发布
  myaudit: '/api/exhibition/myaudit/lang',
  // post新增展览--保存草稿  put修改展览--保存草稿
  myauditDraft: '/api/exhibition/myaudit/draft',
  rejectRecord: '/api/exhibition/myaudit/myreject',
  // 查询审核阶段的展览详情{auditId}
  detail: '/api/exhibition/myaudit/lang/view',
  // 被驳回--获取展览编辑内容{auditId}
  // rejectedit: '/api/exhibition/myaudit/lang/edit',
  // 获取驳回原因内容{auditId}
  getRejectReason: '/api/exhibition/myaudit/rejectreason',
  // 查看展览被平台抽审结束的原因{{unicode}}
  enforceReason: '/api/exhibition/myinfo/endreason',
  // 展览创建者查看-某展览的参展商列表{unicode}
  getMyExhibitorList: '/api/exhibition/myexhibitor/list',
  // 展览创建者查看-某展览的参观者列表{unicode}
  getMyVisitorList: '/api/exhibition/myvisitor/list',
  // 展览创建者查看-某展览的展台搭建列表{unicode}
  getMyShowcaseList: '/api/exhibition/myshowcase/list',
  /**
   * 主办商审核参展商（云上展览）
   */
  auditMyexhibitor: '/api/exhibition/myexhibitor/audit',
  // 置顶
  myExhibitorIsTop: '/api/exhibition/myexhibitor/top',
  mywait: '/api/exhibition/myexhibitor/myun',
  myopen: '/api/exhibition/myexhibitor/mying',
  myend: '/api/exhibition/myexhibitor/myend',

  myVisitorWait: '/api/exhibition/myvisitor/myun',
  myVisitorOpen: '/api/exhibition/myvisitor/mying',
  myVisitorEnd: '/api/exhibition/myvisitor/myend',
  myShowcase: '/api/exhibition/myshowcase/myehlist',
}

export default api
/**
 * 置顶操作
 * @param {*} id 参展记录id
 * @param {*} query.sort 置顶 1-置顶,0-取消置顶
 */
export const putMyexhibitorIsTop = (id, query) => {
  return axios.$put(`${api.myExhibitorIsTop}/${id}${query ? `?${qs.stringify(query)}` : ''}`)
}
export const putAuditMyexhibitor = (param) => {
  return axios.$put(`${api.auditMyexhibitor}`, param)
}
/**
 * 我的展览-展台搭建报名
 */
export const myShowcase = async (query) => {
  const { data } = await axios.$get(`${api.myShowcase}${query ? `?${qs.stringify(query)}` : ''}`)
  // const { data: newServerTime } = await getServerTime()
  // await addExhibitionStatus(newServerTime, data.records)
  return data
}
/**
 * 我的展览-参观报名
 */
export const myVisitorWait = async (query) => {
  const { data } = await axios.$get(`${api.myVisitorWait}${query ? `?${qs.stringify(query)}` : ''}`)
  const { data: newServerTime } = await getServerTime()
  await addExhibitionStatus(newServerTime, data?.records || [])
  return data
}
export const myVisitorOpen = async (query) => {
  const { data } = await axios.$get(`${api.myVisitorOpen}${query ? `?${qs.stringify(query)}` : ''}`)
  const { data: newServerTime } = await getServerTime()
  await addExhibitionStatus(newServerTime, data?.records || [])
  return data
}
export const myVisitorEnd = async (query) => {
  const { data } = await axios.$get(`${api.myVisitorEnd}${query ? `?${qs.stringify(query)}` : ''}`)
  const { data: newServerTime } = await getServerTime()
  await addExhibitionStatus(newServerTime, data?.records || [])
  return data
}
/**
 * 参展商-我的展览-参展报名
 */
export const getMyWait = async (query) => {
  const { data } = await axios.$get(`${api.mywait}${query ? `?${qs.stringify(query)}` : ''}`)
  const { data: newServerTime } = await getServerTime()
  await addExhibitionStatus(newServerTime, data?.records || [])
  return data
}
export const getMyOpen = async (query) => {
  const { data } = await axios.$get(`${api.myopen}${query ? `?${qs.stringify(query)}` : ''}`)
  const { data: newServerTime } = await getServerTime()
  await addExhibitionStatus(newServerTime, data?.records || [])
  return data
}
export const getMyEnd = async (query) => {
  const { data } = await axios.$get(`${api.myend}${query ? `?${qs.stringify(query)}` : ''}`)
  const { data: newServerTime } = await getServerTime()
  await addExhibitionStatus(newServerTime, data?.records || [])
  return data
}
/**
 * 主办方-展览的参展商列表
 * @param {*} unicode 展览id
 * @param {Number} query.status 审核状态 -1不分 0-审核通过,1-审核中,2-拒绝
 */
export const getMyExhibitorList = (unicode, query) => {
  return axios.$get(`${api.getMyExhibitorList}/${unicode}${query ? `?${qs.stringify(query)}` : ''}`)
}
export const getMyVisitorList = (unicode, query) => {
  return axios.$get(`${api.getMyVisitorList}/${unicode}${query ? `?${qs.stringify(query)}` : ''}`)
}
export const getMyShowcaseList = (unicode, query) => {
  return axios.$get(`${api.getMyShowcaseList}/${unicode}${query ? `?${qs.stringify(query)}` : ''}`)
}

// 获取拒绝的原因
export const getRejectReason = (auditId) => {
  return axios.$get(`${api.getRejectReason}/${auditId}`)
}

/**
 * 通过子账号发布的预览
 * @param {*} id 展览的id
 * @returns
 */
export const adoptSubAccountExhibitionAgree = (id) => {
  return axios.$put('/api/exhibition/myaudit/pass', { id })
}

/**
 * 主账号拒绝子账号发布的展览
 * @param {*} id 展览的id
 * @returns
 */
export const adoptSubAccountExhibitionReject = (id) => {
  return axios.$put('/api/exhibition/myaudit/reject', {
    id,
  })
}

export const getEnforceReason = (unicode) => {
  return axios.$get(`${api.enforceReason}/${unicode}`)
}
// 会员终止发布展览{unicode}
export const closeRelease = (unicode) => {
  return axios.$put(`/api/exhibition/myinfo/end/${unicode}`)
}

// 线上展览--编辑---获取展览编辑内容 --查询已发布阶段的展览详情{unicode}
export const getReleaseEditDetail = async (unicode) => {
  const res = await axios.$get(`/api/exhibition/myinfo/lang/edit/${unicode}`)
  if (res.code === 0 && res.data.descriptions) {
    res.data.descriptions = richTextTofront(res.data.descriptions)
  }
  return res
}

// 获取展览列表
export const getReleaseList = async (query) => {
  const { data } = await axios.$get(`${api.releaseList}${query ? `?${qs.stringify(query)}` : ''}`)
  const { data: newServerTime } = await getServerTime()
  await addExhibitionStatus(newServerTime, data?.records || [])
  return data
}
// 获取展览列表（直接返回响应参数）
export const getReleaseListNew = (query) => {
  return axios.$get(`${api.releaseList}${query ? `?${qs.stringify(query)}` : ''}`)
}
// 根据开幕时间,闭幕时间和服务器时间。返回展览状态
export const getExhibitionStatus = async (beginTime, endTime, serverTime) => {
  let thatServerTime = serverTime
  // 获取服务器时间
  if (!thatServerTime) {
    const { data: newServerTime } = await getServerTime()
    thatServerTime = newServerTime
  }

  // 计算展览状态
  return isExStatus(beginTime, endTime, thatServerTime)
}
// 新增展览---立即发布
export const postExhibition = (params, draft) => {
  const param = deepClone(params)
  param.descriptions = richTextToBack(param.descriptions)
  console.log('新增展览', param, draft)
  if (draft) {
    return axios.$post(`${api.myauditDraft}`, param)
  }
  return axios.$post(`${api.myaudit}`, param)
}
// 修改展览---立即发布
export const putExhibition = (params, draft) => {
  const param = deepClone(params)
  param.descriptions = richTextToBack(param.descriptions)
  console.log('修改展览-立即发布', param, draft)
  if (draft) {
    return axios.$put(`${api.myauditDraft}`, param)
  }
  return axios.$put(`${api.myaudit}`, param)
}
// 查询审核发布记录
export const getAuditRecord = (query) => {
  return axios.$get(`/api/exhibition/myaudit/myaudit${query ? `?${qs.stringify(query)}` : ''}`)
}
// 查询已驳回发布记录
export const getRejectRecord = (query) => {
  return axios.$get(`${api.rejectRecord}${query ? `?${qs.stringify(query)}` : ''}`)
}
// 查询详情
export const getDetail = async (auditId) => {
  const res = await axios.$get(`${api.detail}/${auditId}`)
  if (res.code === 0 && res.data.descriptions) {
    res.data.descriptions = richTextTofront(res.data.descriptions)
  }
  return res
}
// 查询历史展览发布记录
// 我发布的展览(所有历史展览)
export const getHistory = (query) => {
  return axios.$get(`/api/exhibition/myinfo/myallend${query ? `?${qs.stringify(query)}` : ''}`)
}

/**
 * 获取展览待审核数据
 * @param {*} query
 * @returns
 */
export const getAuditingNum = (query) => {
  return axios.$get('/api/exhibition/myaudit/auditingNum')
}

// 查询被驳回的展览内容-回显内容编辑
// export const getRejectDetail = async (auditId) => {
//   const { data } = await axios.$get(`${api.rejectedit}/${auditId}`)
//   data.descriptions = richTextTofront(data.descriptions)
//   return data
// }

// 全部-设置排序
export const putExhibitionAllSort = (id, query) => {
  return axios.$put(`/api/exhibition/myexhibitor/sort/${id}${query ? `?${qs.stringify(query)}` : ''}`)
}

// 标签-设置排序
export const putExhibitionSort = (id, query) => {
  return axios.$put(`/api/exhibition/myexhibitor/label/sort/${id}${query ? `?${qs.stringify(query)}` : ''}`)
}

// 加入标签
export const putAddLabel = (param) => {
  return axios.$post('/api/exhibition/myexhibitor/label', param)
}

// 标签列表
export const getMyExhibitionLabelList = (query) => {
  return axios.$get(`/api/my/exhibition/label/page${query ? `?${qs.stringify(query)}` : ''}`)
}

// 隐藏标签
export const putMyExhibitionLabel = (labelId, query) => {
  return axios.$put(`/api/my/exhibition/label/${labelId}${query ? `?${qs.stringify(query)}` : ''}`)
}

// 删除标签
export const delMyExhibitionLabel = (labelId, query) => {
  return axios.$delete(`/api/my/exhibition/label/${labelId}`)
}

// 创建标签
export const postMyExhibitionLabelList = (param) => {
  return axios.$post('/api/my/exhibition/label', param)
}

/**
 * 设置标签排序
 * @param {*} labelId
 * @param {*} query.sort 排序
 * @returns
 */
export const putMyExhibitionLabelSetSort = (labelId, params) => {
  return axios.$put(`/api/my/exhibition/label/${labelId}/sort`, params)
}
